import { createFileRoute } from "@tanstack/react-router";
import { CORRIDORS, CorridorPage, corridorHead } from "@/lib/corridors";

const corridor = CORRIDORS["marrakech-to-essaouira"];

export const Route = createFileRoute("/transfers/marrakech-to-essaouira")({
  head: () => corridorHead(corridor),
  component: () => <CorridorPage corridor={corridor} />,
});
